export default "__VITE_ASSET__DYoWp9PO__"